import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { PlanificadorService } from '../models/control.service';
import { operationinterface } from 'src/app/interface/OperationInterface';
import { CdkTableVirtualScrollDataSource } from 'ng-table-virtual-scroll';
import { TableColmuns } from 'src/app/interface/TableColumnsinterface';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';
import { DiversificadorService } from 'src/app/services/diversificador.services';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-buscador',
  templateUrl: './buscador.component.html',
  styleUrl: './buscador.component.scss'
})
export class BuscadorComponent implements OnInit, OnDestroy {
    public queryParams: string;
    public isPlanificador: boolean = false;
  private opesubcription : Subscription;
  private opesubcriptionDiv : Subscription;
  public opedata = new CdkTableVirtualScrollDataSource<operationinterface>;
  public opedataDiv = new CdkTableVirtualScrollDataSource<operationinterface>;
  showContextMenu = false;
  contextMenuX = 0;
  contextMenuY = 0;
  filaSeleccionada: any = null;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportGestion!: CdkVirtualScrollViewport;
  @ViewChild(CdkVirtualScrollViewport, { static: false }) viewportDiv!: CdkVirtualScrollViewport;
  @Input() context: 'modelo' | 'diversificador';
  @Input() selectedTab2: number =0;
  originalData: operationinterface[] = [];
  originalDataDiv: operationinterface[] = [];
public isDark: boolean = false;
  tableColumns : TableColmuns []=[
    {id: 'contador', name:'#', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'isooper', name:'ID', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'nombreCompania', name:'Nombre', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'fechaOperacion', name:'Fecha', isShow: true, isDate: true, isNumber: false, isString: false},
    {id: 'tipoOperacion', name:'Tipo', isShow: true, isDate: false, isNumber: false, isString: true},
    {id: 'precioentradareal', name:'Precio Entrada', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'stoplossinicial', name:'Stop loss', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'preciosalidareal', name:'Precio Salida', isShow: true, isDate: false, isNumber: true, isString: false},
    {id: 'posicionsimultanea', name:'Cartera', isShow: false, isDate: false, isNumber: false, isString: true},
    {id: 'cantidadacciones', name:'N° Acciones', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'comision', name:'Comision', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'acumuladocomision', name:'Acum Comision', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'costeoperacion', name:'Coste operacion', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'beneficioperdida', name:'Beneficio', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'beneficioacumulado', name:'Acumulado', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'costereembolso', name:'Reembolso Coste', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'riesgooperacion', name:'Riesgo Operacion', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'margentotal', name:'Margen', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'capitalEmpleado', name:'Capital Empleado', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'podercompra', name:'Poder Adquisitivo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'reembolsoriesgo', name:'Reembolso Riesgo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'riesgomaximo', name:'Riesgo Maximo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'fondosdisponibles', name:'Fondos Disponibles', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'valorliquidativo', name:'Valor Liquidativo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'efectivo', name:'Efectivo', isShow: false, isDate: false, isNumber: true, isString: false},
    {id: 'valorlatente', name:'Valor Latente', isShow: false, isDate: false, isNumber: true, isString: false},

   ]

   displayedColumns: string[] = ['nombreCompania', 'fechaOperacion',
                                'tipoOperacion','precioentradareal','preciosalidareal'];
  //filaSeleccionada: any;

  constructor( private toastr: ToastrService, public planificadorsv: PlanificadorService, public diversificadorService: DiversificadorService, 
    private change: ChangeDetectorRef,
  ){

  }

  ngOnInit(): void {
    console.log(this.selectedTab2);
    this.opesubcription = this.planificadorsv.operation$.subscribe((newdata: any)=>{
      let combineData = this.flattenArray(newdata);
      this.originalData = combineData;
      this.opedata = new CdkTableVirtualScrollDataSource(combineData);
      this.change.detectChanges();    
      this.actualizarViewport();
    });
    this.opesubcriptionDiv = this.diversificadorService.divOperaciones.subscribe((newdata: any)=>{
      let combineData = this.flattenArray(newdata);
      this.originalDataDiv = combineData;
      this.opedata = new CdkTableVirtualScrollDataSource(combineData);
      this.change.detectChanges();    
      this.actualizarViewport();
    });
    //hacer un observable para las operaciones de divOperaciones en el servicio DiversificadorService
    //esta data enviarla a otra tabla en el html component
  }



  flattenArray(arrayOfArrays: any[]): any[] {
    
    return arrayOfArrays.flatMap(innerArray => innerArray);
  }
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.opedata = new CdkTableVirtualScrollDataSource(this.originalData.filter(
      (item: operationinterface) => {
        // Implementa tu lógica de filtrado aquí
        // Por ejemplo, si quieres filtrar por el campo 'nombre':
        return item.nombreCompania.toLowerCase().includes(filterValue);
      }
    ));
  }
  applyFilterDiv(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.trim().toLowerCase();
    this.opedataDiv = new CdkTableVirtualScrollDataSource(this.originalDataDiv.filter(
      (item: operationinterface) => {
        // Implementa tu lógica de filtrado aquí
        // Por ejemplo, si quieres filtrar por el campo 'nombre':
        return item.nombreCompania.toLowerCase().includes(filterValue);
      }
    ));
  }
  selectRow(row: any){
    this.filaSeleccionada=row;
    console.log("selectRow(row: any){ ", this.filaSeleccionada.fechaOperacion);
    this.planificadorsv.updatefechaBuscador(this.filaSeleccionada.fechaOperacion);    
  }

  ngOnChanges(changes: SimpleChanges): void {

    if(this.selectedTab2 === 1 ){
      this.actualizarViewport();
      this.change.detectChanges();
   
      
/*       if(this.modelo){
        if (this.indexGes !== -1) {
          if(this.viewportGestion){ this.viewportGestion.scrollToIndex(this.indexGes-5);}
        }
      }else if(this.isPlanificador){
        if (this.indexGesDiv !== -1) {
          if(this.viewportGestionDiv){this.viewportGestionDiv.scrollToIndex(this.indexGesDiv-5);}
        }
      }else if(this.isGestion){
        if (this.indexGestion !== -1) {
          if(this.viewportGestionGest){this.viewportGestionGest.scrollToIndex(this.indexGestion-5);}  
        }
      }else if(this.isBroker){
        if (this.indexBrok !== -1) {
          if(this.viewportGestionBrok){this.viewportGestionBrok.scrollToIndex(this.indexBrok-5);}  
        }
      } */
 
    }
  }

  actualizarViewport() {
    if (this.viewportGestion) {
      this.viewportGestion.checkViewportSize();
      this.viewportGestion.checkViewportSize();
    }
  }

  actualizarViewportDiv() {
    if (this.viewportDiv) {
      this.viewportDiv.checkViewportSize();
      this.viewportDiv.checkViewportSize();
    }
  }
  mostrarMenu(event: MouseEvent, data: any) {
    event.preventDefault(); // Evitar menú contextual del navegador
    this.filaSeleccionada = data;
    this.showContextMenu = true;
    this.contextMenuX = event.clientX;
    this.contextMenuY = event.clientY;
    
    // Cerrar el menú cuando se hace clic en cualquier parte de la página
    setTimeout(() => {
      window.addEventListener('click', this.closeContextMenu);
    });
  }
  
  closeContextMenu = () => {
    this.showContextMenu = false;
    window.removeEventListener('click', this.closeContextMenu);
  }
  
  verModelo() {
    if (this.filaSeleccionada) {
      console.log('Ver modelo para:', this.filaSeleccionada);
      // Implementar la lógica para ver el modelo
      // Por ejemplo, navegar a otra ruta o abrir un diálogo
      const jsonData = {
        idNectum: this.filaSeleccionada.idNectum,
        nombreComp: this.filaSeleccionada.nombreCompania,
        idModelo: this.filaSeleccionada.idmodelo,
        isModelo: 'modelo',
        fecha: this.filaSeleccionada.fechaOperacion
      };
      this.queryParams = new URLSearchParams(jsonData).toString();
      window.open('/grafica-modelo/' + this.queryParams, '_blank');
    
    }else {
      this.showToast('Selecciona correctamente el activo para ver modelo.');
    }
  }
  
  verGrafica() {
    if (this.filaSeleccionada) {
      console.log('Ver gráfica para:', this.filaSeleccionada);
      // Implementar la lógica para ver la gráfica
      // Por ejemplo, navegar a otra ruta o abrir un diálogo
    }
  }

   private showToast(message: string) {
    this.toastr.success(message, '', { timeOut: 3000, positionClass: 'toast-bottom-center' });
  }

  ngOnDestroy(): void {
    this.opesubcription.unsubscribe();
    this.opesubcriptionDiv.unsubscribe();
    window.removeEventListener('click', this.closeContextMenu);

  }

}
